<div class="find-clip-panel">
  <!-- Header -->
  <div class="find-clip-panel__header">
    <h2 class="find-clip-panel__title">Find Clip</h2>
  </div>

  <!-- Scrollable body -->
  <div class="find-clip-panel__body">
    <!-- Description textarea -->
    <div class="find-clip-panel__section">
      <textarea
        class="find-clip-panel__textarea"
        [(ngModel)]="description"
        placeholder="Describe the clips you want to find..."
        (keydown)="$event.stopPropagation()"
      ></textarea>
    </div>

    <!-- Recent Prompts -->
    <div class="find-clip-panel__section">
      <div class="find-clip-panel__section-label">Recent Prompts</div>
      <p class="find-clip-panel__error-text" *ngIf="promptsError()">{{ promptsError() }}</p>
      <p class="find-clip-panel__loading" *ngIf="promptsLoading()">Loading…</p>
      <p class="find-clip-panel__empty-hint" *ngIf="!promptsLoading() && recentPrompts().length === 0">No recent prompts yet. Your prompts will appear here after you generate clips.</p>
      <div class="find-clip-panel__prompts" *ngIf="!promptsLoading() && recentPrompts().length > 0">
        <button
          *ngFor="let prompt of recentPrompts(); trackBy: promptTrackBy"
          type="button"
          class="find-clip-panel__prompt-btn"
          [disabled]="!prompt?.trim()"
          (click)="onSelectPrompt(prompt)"
        >
          <span class="find-clip-panel__prompt-text">{{ prompt }}</span>
        </button>
      </div>
    </div>

    <!-- Duration selector (same component as Create live event) -->
    <div class="find-clip-panel__section">
      <label class="find-clip-panel__section-label">Duration</label>
      <icn-dropdown
        class="find-clip-panel__dropdown"
        [selectedValue]="duration"
        (selectedValueChange)="duration = $event"
        [position]="'bottom'"
        [medium]="true"
        [allowMultiple]="false"
        [textAlign]="'left'"
      >
        <icn-dropdown-item [title]="'15 seconds'" [value]="'15s'"></icn-dropdown-item>
        <icn-dropdown-item [title]="'30 seconds'" [value]="'30s'"></icn-dropdown-item>
        <icn-dropdown-item [title]="'45 seconds'" [value]="'45s'"></icn-dropdown-item>
        <icn-dropdown-item [title]="'60 seconds'" [value]="'60s'"></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <!-- Generate Buttons -->
    <div class="find-clip-panel__actions" *ngIf="canGenerateClips; else noVideoHint">
      <button
        type="button"
        class="find-clip-panel__btn find-clip-panel__btn--primary"
        [disabled]="isGenerating || isGeneratingEdit || !description?.trim()"
        (click)="onGenerate()"
      >
        <ng-container *ngIf="isGenerating; else generateClipsIdle">
          <span class="find-clip-panel__spinner"></span>
          Generating Clips...
        </ng-container>
        <ng-template #generateClipsIdle>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
          </svg>
          Generate Clips
        </ng-template>
      </button>

      <button
        type="button"
        class="find-clip-panel__btn find-clip-panel__btn--secondary"
        [disabled]="isGenerating || isGeneratingEdit || !description?.trim()"
        (click)="onGenerateEdit()"
      >
        <ng-container *ngIf="isGeneratingEdit; else generateEditIdle">
          <span class="find-clip-panel__spinner find-clip-panel__spinner--secondary"></span>
          Generating Edit...
        </ng-container>
        <ng-template #generateEditIdle>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m22 8-6 4 6 4V8Z" />
            <rect width="14" height="12" x="2" y="6" rx="2" ry="2" />
          </svg>
          Generate Full Edit
        </ng-template>
      </button>
    </div>
    <ng-template #noVideoHint>
      <div class="find-clip-panel__section find-clip-panel__no-video">
        <p class="find-clip-panel__no-video-text">Open a video from the Media tab to use Find Clips.</p>
      </div>
    </ng-template>

    <!-- Error message -->
    <div class="find-clip-panel__section find-clip-panel__error" *ngIf="errorMessage">
      <p class="find-clip-panel__error-text">{{ errorMessage }}</p>
    </div>

    <!-- Results -->
    <div class="find-clip-panel__results" *ngIf="hasResults || isGenerating || isGeneratingEdit">
      <!-- Results header with clear -->
      <div class="find-clip-panel__results-header" *ngIf="hasResults">
        <h3 class="find-clip-panel__results-title">
          {{ suggestedEdit ? 'Suggested Edit' : 'Suggested Clips' }}
        </h3>
        <button
          type="button"
          class="find-clip-panel__clear-btn"
          (click)="onClear()"
        >Clear</button>
      </div>

      <!-- Suggested Edit card -->
      <div class="find-clip-panel__edit-card" *ngIf="suggestedEdit">
        <div class="find-clip-panel__edit-card-top">
          <div class="find-clip-panel__edit-card-icon">
            <svg width="24" height="16" viewBox="0 0 21 14" fill="currentColor" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.160,11.177 C19.938,11.307 19.695,11.373 19.451,11.373 C19.209,11.373 18.965,11.307 18.744,11.178 L15.537,9.299 C15.537,9.299 13.622,8.157 13.567,8.112 L13.567,5.886 C13.622,5.841 15.537,4.700 15.537,4.700 L18.743,2.821 C19.188,2.561 19.717,2.562 20.160,2.821 C20.603,3.081 20.868,3.546 20.868,4.066 L20.868,9.933 C20.868,10.452 20.603,10.918 20.160,11.177 ZM19.166,4.566 L15.537,6.693 L15.537,7.306 L19.166,9.432 L19.166,4.566 ZM13.567,1.999 L2.809,1.999 L2.809,11.999 L13.567,11.999 L13.567,9.335 C13.622,9.380 15.537,10.522 15.537,10.522 L15.537,13.999 L0.839,13.999 L0.839,-0.001 L15.537,-0.001 L15.537,3.379 C15.537,3.379 13.622,4.521 13.567,4.566 L13.567,1.999 Z"/>
            </svg>
          </div>
          <div class="find-clip-panel__edit-card-info">
            <h4 class="find-clip-panel__edit-card-title">{{ suggestedEdit.title }}</h4>
            <p class="find-clip-panel__edit-card-meta">
              {{ suggestedEdit.clipsCount }} Clips &bull; {{ suggestedEdit.duration }}
            </p>
          </div>
        </div>
        <button
          type="button"
          class="find-clip-panel__btn find-clip-panel__btn--add-edit"
          (click)="onAddEditToTimeline()"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
          Add Edit to Timeline
        </button>
      </div>

      <!-- Suggested Clips -->
      <div
        class="find-clip-panel__clip-card"
        *ngFor="let clip of suggestedClips"
      >
        <div
          class="find-clip-panel__clip-thumbnail"
          [ngStyle]="getClipThumbnailStyle(clip)"
        >
          <svg
            *ngIf="!getClipThumbnailStyle(clip)"
            width="32"
            height="22"
            viewBox="0 0 21 14"
            fill="currentColor"
            fill-rule="evenodd"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M20.160,11.177 C19.938,11.307 19.695,11.373 19.451,11.373 C19.209,11.373 18.965,11.307 18.744,11.178 L15.537,9.299 C15.537,9.299 13.622,8.157 13.567,8.112 L13.567,5.886 C13.622,5.841 15.537,4.700 15.537,4.700 L18.743,2.821 C19.188,2.561 19.717,2.562 20.160,2.821 C20.603,3.081 20.868,3.546 20.868,4.066 L20.868,9.933 C20.868,10.452 20.603,10.918 20.160,11.177 ZM19.166,4.566 L15.537,6.693 L15.537,7.306 L19.166,9.432 L19.166,4.566 ZM13.567,1.999 L2.809,1.999 L2.809,11.999 L13.567,11.999 L13.567,9.335 C13.622,9.380 15.537,10.522 15.537,10.522 L15.537,13.999 L0.839,13.999 L0.839,-0.001 L15.537,-0.001 L15.537,3.379 C15.537,3.379 13.622,4.521 13.567,4.566 L13.567,1.999 Z"/>
          </svg>
          <span class="find-clip-panel__clip-confidence">{{ clip.confidence }}%</span>
        </div>
        <div class="find-clip-panel__clip-info">
          <h4 class="find-clip-panel__clip-title">{{ clip.title }}</h4>
          <p class="find-clip-panel__clip-meta">{{ clip.timestamp }} &bull; {{ clip.duration }}</p>
        </div>
        <button
          type="button"
          class="find-clip-panel__btn find-clip-panel__btn--add-clip"
          (click)="onAddClipToTimeline(clip)"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
          Add Clip to Timeline
        </button>
      </div>
    </div>

    <!-- Empty state -->
    <div class="find-clip-panel__empty" *ngIf="showEmptyState">
      <p class="find-clip-panel__empty-text">
        Describe what you're looking for and click generate to see suggestions.
      </p>
    </div>
  </div>
</div>
